module.exports = __webpack_public_path__ + "img/purple-3-diamond-solid.cb3fb4e0.svg";